import React, { useEffect, FC } from 'react'
import { Form, Input, Button, Card } from 'antd'
import { debounce, compact } from 'lodash-es'
import { connect } from 'react-redux'
import { setCommonConfig } from '@/store/actions/index'
const initialValues = [
  {
    text: '',
  },
]
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
}

interface NoticeBarProps {
  editConfig: (id, name, value) => void
  id: string
  pid: string
  config: {
    list?: {
      text: string
      normallink?: string
      deeplink?: string
    }[]
  }
}
const NoticeBar: FC<NoticeBarProps> = ({ editConfig, id, config }) => {
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue({
      list: config?.list || initialValues,
    })
  }, [config, form])

  const getValue = debounce(() => {
    editConfig(id, 'list', compact(form.getFieldValue('list')))
  }, 400)
  const handleFieldsChange = () => {
    getValue()
  }
  return (
    <Card>
      <Form {...layout} onFieldsChange={handleFieldsChange} form={form}>
        <Form.List name="list">
          {(fields, { add, remove }) => (
            <>
              {fields.map(field => (
                <Card
                  key={field.key}
                  extra={
                    fields?.length > 1 ? (
                      <Button onClick={() => remove(field.name)} type="primary" danger size="small">
                        delete
                      </Button>
                    ) : null
                  }
                >
                  <Form.Item
                    label="text"
                    {...field}
                    name={[field.name, 'text']}
                    rules={[{ required: true, message: 'place input text' }]}
                  >
                    <Input placeholder="text" />
                  </Form.Item>
                  <Form.Item label="deeplink" name={[field.name, 'deeplink']}>
                    <Input placeholder="deeplink" />
                  </Form.Item>
                  <Form.Item label="normallink" {...field} name={[field.name, 'normallink']}>
                    <Input placeholder="normallink" />
                  </Form.Item>
                  {/* <Button onClick={() => remove(name)} /> */}
                </Card>
              ))}
              <Form.Item>
                <Button onClick={() => add({ text: '' })} block type="primary">
                  Add
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Card>
  )
}

const mapDispatchToProps = dispatch => ({
  editConfig: (id, name, value) => {
    dispatch(setCommonConfig(id, name, value))
  },
})
const mapStateToProps = state => ({
  domain: state.tree.root.config.domain,
})
export default connect(mapStateToProps, mapDispatchToProps)(NoticeBar)
